// Copyright (c) 2021. Comsearch, Inc., All rights reserved

/**
 * returns the derived Longitude Cardinal value
 * @param {String} prefix - "E", "W", "-" or ""
 * @param {Boolean} preferWesternHemisphere - allows us to default positive values with no prefix to W instead of E
 * @returns {string|null}
 */
const deriveDirectionLongitude = (prefix, preferWesternHemisphere) => {
  // ensure that the prefix passed here is correct for Longitude
  if (!prefix.match(/^[EW-]?$/)) {
    return null
  }

  return (
    // if the prefix is ether E or W, just return that
    prefix.match(/^[EW]$/) && prefix ||
    // if the prefix is a negative sign, then send them to W hemisphere!
    prefix === '-' && 'W' ||
    // For ease of use in N. America, we give preference to W when parsing user provided data.
    preferWesternHemisphere && 'W' ||
    // finally if we're here, that means that prefix was an empty string and we're not defaulting to W, so make it E
    'E'
  )
}

export default deriveDirectionLongitude
